import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

interface ErrorStateProps {
  title?: string;
  description: string;
  action?: ReactNode;
}

export function ErrorState({
  title = 'Unable to load data',
  description,
  action,
}: ErrorStateProps) {
  return (
    <div className="flex min-h-44 flex-col items-center justify-center gap-3 rounded-xl border border-status-danger/45 bg-status-danger/10 p-6 text-center">
      <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-status-danger/20">
        <AlertTriangle className="h-6 w-6 text-status-danger" />
      </div>
      <p className="font-medium text-foreground">{title}</p>
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>
      {action ? <div className="pt-2">{action}</div> : null}
    </div>
  );
}

